export default "__VITE_PUBLIC_ASSET__b4222f93__"